var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogoColorMobile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 128.14 134.59",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: url(#linear-gradient-2);\n      }\n\n      .cls-2 {\n        fill: url(#linear-gradient);\n      }\n    "), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 108.29,
    y1: 145.26,
    x2: -34.01,
    y2: -33.47,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#ee7400"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#d00000"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 109.96,
    y1: 143.48,
    x2: -32.07,
    y2: -34.9,
    xlinkHref: "#linear-gradient"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M22.84,22.9v30.08h.01v-30.08ZM54.18,89.21l9.03,13.23c-2.88-4.66-5.76-9.23-9.03-13.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M127.88,127.87c-.71-.46-7-2.36-8.44-2.92-11.61-4.51-15.43-8.42-22.16-17.55-1.13-1.53-2.23-3.09-3.29-4.66l-21.69-32.28c6.31-2.96,11.19-7.07,14.66-12.34,3.67-5.58,5.51-12.33,5.51-20.25,0-11.74-4.02-20.99-12.04-27.74S60.86,0,45.79,0H0v102.74h29.06v-27.3h15.72l7.17,10.51,2.23,3.26c3.27,4,6.15,8.57,9.03,13.23,8.38,13.59,16.71,27.97,34.51,31.51,2.06.41,4.2.5,6.29.57,3.83.14,7.68.07,11.49-.28,1.42-.13,2.83-.31,4.24-.56s2.7-.5,3.95-1.03c.05-.02.1-.04.15-.07,1.08-.48,2.07-1.19,2.88-2.06.37-.39.75-.82,1.05-1.27.22-.33.55-.88.25-1.27-.04-.05-.09-.09-.15-.13ZM61.75,45.07c-5.1,3.61-13.61,4.46-24.45,4.55-1.32,1.31-2.45,2.39-3.51,3.36-1.58,1.44-3.01,2.63-4.73,3.94-.87.67-1.81,1.37-2.88,2.15-.54.39-1,.67-1.4.82-.45.17-.81.17-1.09,0-.49-.3-.76-1.15-.84-2.65v-4.26h-.01V19.19c.08-1.18,1.34-2.35,2.56-2.42,1.19,0,2.41-.01,3.66-.01,10.25-.03,21.85-.07,26.14.58,8.6,1.3,12,4.94,11.89,16.29-.05,5.42-1.94,9.04-5.34,11.44Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoColorMobile);
export default __webpack_public_path__ + "static/media/logo_color_mobile.4197f43d3b629f99189ec3c6479a8b14.svg";
export { ForwardRef as ReactComponent };